// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__XnR0n","description":"PatientConsentPreview_description__3NTTL"};